import {useSelector} from "react-redux";
import React, {memo, useCallback, useContext, useEffect, useState} from "react";
import {useTranslation, withTranslation} from "react-i18next";
import {Context} from "../../context/MainSearchContext";
import {getList} from "../../services/accessoryService";
import {IoAddCircleOutline} from "react-icons/io5";
import Select from "../../components/Select";
import MainSearchInput from "../../components/search/MainSearchInput";
import TemDataTableInline from "../../components/TemDataTableInline";
import Pagination from "../../components/Pagination";
import DeleteButton from "../../components/DeleteButton";
import EditButton from "../../components/EditButton";
import swal from "sweetalert";
import {deleteItem} from "../../services/service";
import {toast} from "react-toastify";
import ModalEditAccessoriesSide from "../../components/accessories/ModalEditAccessoriesSide";
import AddParamComponent from "../../components/addParamComponent/addParamComponent";
import {useNavigate} from "react-router-dom";
import TextureMatchingModal from "../../components/texture/TextureMatchingModal";

const headerTable = [{
    name: "id", sort: false
}, {
    name: "laminate", sort: false
}, {
    name: "name", sort: true
}, {
    name: "color", sort: false
}, {
    name: "type", sort: false
}, <span className="sr-only">Edit</span>,];


const bodyTable = ["id", "imageId", "name", "color", "matchingSideType", "actions"];

function TextureMatching({selectedId}) {
    const navigate = useNavigate();
    const {token} = useSelector((state) => state.user);
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [isEdit, setIsEdit] = useState(false)
    const [rowId, setRowId] = useState(null);


    const {t} = useTranslation();
    const ctx = useContext(Context);

    const fetchData = async () => {
        const responce = await getList(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/texture/matching/list/${selectedId}`,
            token
        );
        setData(responce.res.map((item, index) => {
            return {
                ...item,
                name: item?.matchingTextureDto.name,
                color: (
                    <div
                        style={{backgroundColor: `${item?.matchingTextureDto.color}`}}
                        className={` w-full h-6 rounded-lg `}
                    ></div>
                ),
                imageId: item.imageId ? (
                    <img
                        className="object-cover w-6 h-6 rounded-full"
                        src={`${process.env.REACT_APP_HOST_BASE_URL}/v1/file/texture/${item?.matchingTextureDto.imageId}`}
                        alt={"img"}
                    />
                ) : (
                    <p className=" text-[16px] font-bold ">{t(`no_laminate`)}</p>
                ),
                actions: (
                    <div className="flex justify-end mt-3 sm:mt-0 sm:ml-4">
                        <EditButton onclick={() => editHandler(item)}/>
                        <DeleteButton onclick={() => deleteHandler(item.id)}/>
                    </div>
                )
            }
        }));
    }

    const sortFunction = (value) => {

    }

    useEffect(() => {
        fetchData();
    }, [selectedId]);

    const editHandler = async (item) => {
        setRowId(item.id);
        setOpen(true);
        setIsEdit(true);
    };
    const handleOpen = () => {
        setIsEdit(false)
        setRowId(null)
        setOpen(true);
    }
    const handleClose = useCallback(() => {
        setOpen(false);
        setIsEdit(false);
    }, [open]);

    const getDataAfterSaveHandler = useCallback(() => {
        fetchData()
    }, [selectedId])

    const deleteHandler = async (id) => {
        const responseReceived = await swal({
            title: t(`action.delete_item.title`),
            text: t(`action.delete_item.text`),
            icon: "warning",
            buttons: {
                cancel: true,
                confirm: true,
            },
        });
        if (responseReceived) {
            const response = await deleteItem(
                `${process.env.REACT_APP_HOST_BASE_URL}/v1/texture/matching/${id}`,
                token
            );
            if (response.success) {
                fetchData();
                toast.success(t('action.delete_success'), {
                    position: "bottom-right",
                    autoClose: 3000,
                    closeOnClick: true,
                    className: "add-success"
                });
            } else {
                navigate("/error", {
                    state: {
                        status: response.status,
                        message: response.message ? response.message : null,
                    },
                });
            }
        } else {
            return;
        }
    };

    return (
        <>
            <TextureMatchingModal
                textureId={selectedId}
                rowId={rowId}
                open={open}
                setOpen={setOpen}
                fetchData={fetchData}
            />
            {isLoading ? (
                <h1>Loading...</h1>
            ) : (
                <>
                    <div className="flex items-center justify-between">
                        <h1 className="text-xl font-semibold text-gray-900">
                            {t(`textureMatching`)}
                        </h1>
                        <button
                            className={`${
                                selectedId
                                    ? "flex items-center px-3 py-1 text-sm font-medium leading-4 text-white bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                                    : "cursor-no-drop flex items-center px-3 py-1 text-sm font-medium leading-4 text-white bg-indigo-300 border border-transparent rounded-md shadow-sm "
                            }`}
                            onClick={handleOpen}
                            disabled={selectedId ? false : true}
                        >
                            {t('action.add')}
                            <IoAddCircleOutline className="w-4 h-4 ml-1"/>
                        </button>
                    </div>

                    <TemDataTableInline
                        data={data}
                        bodyContent={bodyTable}
                        headerTable={headerTable}
                        sortFunction={sortFunction}
                    />

                </>
            )}
        </>
    );
}

export default withTranslation()(memo(TextureMatching))